module.exports = __webpack_public_path__ + "static/vortune_main_2-1bb6da9f5a0fde9f77fa39b6f54c1b26.png";